module.exports = __webpack_public_path__ + "static/media/icon_n.db0e0b21.svg";